<!--产业链-->
<template>
  <div class="chain-container">
    <div class="chain-content">
      <div class="chain-search-menu">
        <p class="chain-title">产业链</p>
        <div class="chain-search">
          <div class="chain-select-menu">
            <span class="small-title">产业分类</span>
            <div class="el-select-menu">
              <el-select v-model="industry" placeholder="请选择" @change="handleChange">
                <el-option v-for="item in industryList" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="chain-menu">
            <span class="small-title">{{ chainName }}产业链</span>
            <div class="el-select-menu">
              <el-radio-group v-model="chain">
                <el-radio-button v-for="list of chainList" :label="list.value">{{ list.label }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="chain-content-info">
        <p class="chain-title">搜索到<span class="red-span">{{ tablePage.total }}</span>个结果</p>
        <template v-if="industrialChainInfo.length>0">
          <div class="chain-info-list" v-for="chain of industrialChainInfo" @click="enterpriseDetails(chain)">
            <el-container>
              <el-aside width="110px">
                <el-image shape="square" fit="contain" style="width: 90px;height: 90px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                          draggable="false" :src="chain.companyLogo" v-if="chain.companyLogo!=null &&
                    chain.companyLogo!='' && chain.companyLogo!='None' &&
                    chain.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    chain.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    chain.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    chain.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                  <div slot="error" class="image-slot">
                    <div class="logo-keyword" :style="'background:rgb(39, 64, 139);'" v-if="chain.entLogoWord">
                      <span v-for="(logo,index) of logoWord(chain.entLogoWord)" class="logo-word" v-if="index<4">{{ logo }}</span>
                    </div>
                    <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                      <span v-for="(b,index) of logoWord(chain.companyName)" class="logo-word" v-if="index<4">{{b}}</span>
                    </div>
                  </div>
                </el-image>
                <el-avatar shape="square" fit="scale-down" v-else :size="100">
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-if="chain.entLogoWord">
                    <span v-for="(ent,index) of logoWord(chain.entLogoWord)" class="logo-word"v-if="index<4">{{ ent }}</span>
                  </div>
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(logo,index) of logoWord(chain.companyName)" class="logo-word" v-if="index<4">
                      {{ logo }}
                    </span>
                  </div>
                </el-avatar>
              </el-aside>
              <el-main>
                <label class="item-describe SourceHanSansCN">{{ chain.companyName }}</label>
                <!--1在业 2存续 3吊销 4注销 5迁出-->
                <span v-if="chain.status!=null">
                  <i class="label-green" style="float: right;"
                     v-if="chain.status=='开业' || chain.status=='在业' || chain.status==1">{{ chain.status }}</i>
                  <i class="label-red" style="float: right;" v-else-if="!chain.status">未知</i>
                  <i class="label-red" style="float: right;" v-else>{{ chain.status }}</i>
                </span>
                <div style="margin-top: 15px;">
                  <i class="item-label" v-for="sign of chain.kjLabel">{{ sign }}</i>
                </div>
                <div class="item-small" style="padding-top: 15px;">
                  <span>法定代表人：</span>
                  <span style="color: #333333">{{ chain.mname || '-' }}</span>
                  <span style="padding-left: 40px;">注册资本：</span>
                  <span style="color: #333333">{{ chain.registeredCapital || '-' }}</span>
                  <span style="padding-left: 40px;">成立时间：</span>
                  <span style="color: #333333">{{ chain.establishTime || '-' }}</span>
                  <span style="padding-left: 40px;">统一社会信用代码：</span>
                  <span style="color: #333333">{{ chain.unifiedSocialCreditCode || '-'}}</span>
                </div>
                <div class="item-small">
                  <span>地址：</span>
                  <span style="color: #333333">{{ chain.address==0 || !chain.address || chain.address=='0' ? '-' : chain.address}}</span>
                </div>
              </el-main>
            </el-container>
          </div>
          <div style="padding:10px 10px 0px;">
            <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize"
                  style="float: right;"/>
          </div>
        </template>
        <template v-else>
          <el-empty description="暂无内容"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import {industrialChainList, industrialChainCompanyList} from '@/api/enterprise_searchApi'

export default {
  name: "industrialChain",
  components: {page},
  computed:{
    logoWord(){
      return function (word){
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  data() {
    return {
      industry: [],
      industryList: [],
      industrialChainInfo:[],
      chain: '',
      chainName: '',
      chainList: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  watch: {
    chain(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getIndustrialChainInfo();
      }
    },
  },
  methods: {
    /*获取产业链列表数据*/
    getIndustrialChainInfo() {
      industrialChainCompanyList({
        id: this.chain,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.content.total);
          this.industrialChainInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    handleChange(value) {
      for (let list of this.industryList) {
        if (value == list.value) {
          this.chainList = list.children;
          this.chainName = list.label;
          this.chain = list.children[0].value;
        }
      }
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getIndustrialChainInfo();
    },
    /*获取产业分类*/
    getIndustrialChainList() {
      industrialChainList().then(res => {
        if (res.code == 200) {
          let items = res.content;
          for (let a = 0; a < items.length; a++) {
            let item = {}
            if (items[a].sonList != undefined && items[a].sonList.length > 0) {
              item = {value: items[a].id, label: items[a].name, children: []}
              for (let son of items[a].sonList) {
                let son_list = {value: son.id, label: son.name}
                item.children.push(son_list);
              }
            } else {
              item = {value: items[a].id, label: items[a].name}
            }
            this.industryList.push(item);
            if (a == 0) {
              this.chainName = res.content[a].name;
              this.industry = res.content[a].id;
              this.chain = res.content[a].sonList[0].id;
              for (let li of res.content[a].sonList) {
                this.chainList.push({value: li.id, label: li.name});
              }
            }
          }
        }
      })
    },
    /*随机生成颜色值*/
    createRandomColor() {
      let num=Math.floor(Math.random()*9+1);
      let colorList=['#7db3d9','#d1ae9d','#ca8484','#bc9edd','#8B658B','#B22222','#27408B','#008B8B','#5D478B','#68228B'];
      return colorList[num];
    },
    /*查看企业详情*/
    enterpriseDetails(row){
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:row.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getIndustrialChainList();
  }
}
</script>
<style scoped>
.chain-container >>> .chain-content .chain-search-menu .el-radio-button__inner {
  background: #FFF;
  border: none;
  font-weight: 500;
  color: #333333;
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 6px;
}

.chain-container >>> .chain-content .chain-search-menu .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFFFFF;
  background-color: #1637FF;
  border: none;
  -webkit-box-shadow: 0 0 0 0 #333333;
  box-shadow: 0 0 0 0 #333333;
}
.chain-container >>> .el-avatar > img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.chain-container >>> .el-avatar {
  background: white;
  border: 0.0625rem solid rgba(0, 0, 0, .35);
  border-radius: 0.25rem;
  padding: 0.3125rem;
}
.chain-container >>> .el-card__body, .el-main {
  padding: 0px 0px 0px 15px;
}
</style>
<style scoped lang="scss">
.chain-container {
  .chain-content {
    .chain-search-menu {
      .chain-title {
        padding: 20px;
        margin-block-start: 0px;
        margin-block-end: 0px;
        font-size: 14px;
        font-family: "SourceHanSansCN";
        color: #333333;
        border-bottom: 1px solid #EBEDF6;
      }
      .chain-select-menu {
        display: flex;
        justify-content: left;
        padding: 20px;
        align-items: center;
        .small-title {
          font-size: 14px;
          font-family: "SourceHanSansCN";
          color: #999999;
          display: inline-block;
          padding-right: 30px;
          width: 140px;
        }
        .el-select-menu {
          width: 80%;
        }
      }
      .chain-menu {
        display: flex;
        justify-content: left;
        padding: 20px;
        .small-title {
          font-size: 14px;
          font-family: "SourceHanSansCN";
          color: #999999;
          display: inline-block;
          padding-right: 30px;
          width: 140px;
        }
        .el-select-menu {
          width: 80%;
        }
      }
    }
    .chain-content-info {
      .chain-title {
        font-size: 14px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        display: flex;
        margin-block-end: 0px;
        margin-block-start: 0px;
        border-top: 20px solid #F5F5F5;
        padding: 20px;
        border-bottom: 1px solid #F5F5F5;
        .red-span {
          color: #fe273b;
        }
      }
      .chain-info-list {
        padding: 20px;
        border-bottom: 1px solid #E7E9F5;
        .logo-keyword {
          height: 88px;
          width: 88px;
          font-size: 28px;
          color: #ffffff;
          font-weight: 500;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          margin: 0px;
          .logo-word {
            width: 36%;
            height: 34%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .item-label {
          border: 1px solid #E1E5FF;
          padding: 5px 8px;
          color: #1637FF;
          background: #E1E5FF;
          font-style: normal;
          border-radius: 6px;
          margin-right: 10px;
        }

        .label-red {
          padding: 5px 8px;
          color: #FF0000;
          background: #FFDDE0;
          font-style: normal;
          border-radius: 6px;
          margin-right: 10px;
          border: 1px solid #FFDDE0;
        }

        .label-green {
          padding: 5px 15px;
          color: #00A980;
          background: #FFFFFF;
          font-style: normal;
          border-radius: 4px;
          margin-right: 10px;
          border: 1px solid #00A980;
        }

        .item-describe {
          padding: 20px 0 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }

        .item-small {
          color: #999999;
          font-size: 14px;
          padding-top: 5px;
        }
      }
    }
  }
}
</style>